import { render, staticRenderFns } from "./EmploymentDetailModal.vue?vue&type=template&id=bf2f15ea&scoped=true&"
import script from "./EmploymentDetailModal.vue?vue&type=script&lang=js&"
export * from "./EmploymentDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./EmploymentDetailModal.vue?vue&type=style&index=0&id=bf2f15ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf2f15ea",
  null
  
)

export default component.exports